export default __webpack_public_path__ + "static/media/bytetrade.108e9469.png";